/**
 * Contexto para gerenciar o carregamento global do Google Maps API
 * Evita múltiplos carregamentos da API
 */

import React, { createContext, useContext, useState } from "react";
import { useLoadScript } from "@react-google-maps/api";

// Arrays estáticos para evitar recarregamento do script
const libraries = ["places"];
const emptyLibraries = [];

const GoogleMapsContext = createContext({
  isLoaded: false,
  loadError: null,
  apiKey: null,
});

export const useGoogleMaps = () => {
  const context = useContext(GoogleMapsContext);
  if (!context) {
    throw new Error("useGoogleMaps must be used within GoogleMapsProvider");
  }
  return context;
};

export const GoogleMapsProvider = ({ children }) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const [shouldLoad, setShouldLoad] = useState(!!apiKey);

  // Usa useMemo para garantir que o objeto de configuração não mude a cada render
  const loadScriptOptions = React.useMemo(
    () => ({
      googleMapsApiKey: shouldLoad && apiKey ? apiKey : "",
      libraries: shouldLoad && apiKey ? libraries : emptyLibraries,
      preventGoogleFontsLoading: true,
    }),
    [shouldLoad, apiKey]
  );

  const { isLoaded, loadError } = useLoadScript(loadScriptOptions);

  return (
    <GoogleMapsContext.Provider
      value={{
        isLoaded,
        loadError,
        apiKey,
      }}
    >
      {children}
    </GoogleMapsContext.Provider>
  );
};

